import BuildYourCover from '../../../src/client/pages/build-your-cover';

export default BuildYourCover;
